import React from 'react';

import InputLabel from '../../widgets/input-label';
import InputCost from '../../widgets/input-cost';

import SVGIcon from '../../../../../../../common/react/components/svg-icon';
import Localization from '../../../../../../../common/edlio-js/models/BackendLocalization';

export default class MultiChoicePayOption extends React.Component {
	constructor(props) {
		super(props);

		this.localization = new Localization(window.edlio.localizations);
	}

	get displayPlaceholderLabel() {
		const { data, usePlaceholderLabel } = this.props;
		const { label, placeholder } = data;

		if (usePlaceholderLabel == null) {
			if (label === placeholder) {
				return true;
			}
		} else {
			return usePlaceholderLabel;
		}
	}

	get displayCost() {
		const { cost } = this.props.data;

		return cost ? cost : '';
	}

	render() {
		const { localization } = this;
		const { label, placeholder } = this.props.data;

		return (
			<div className='multi-choice-pay-option radio input'>
				<SVGIcon name='filled-circle' />

				<InputCost ref='cost' cost={localization.localize(this.displayCost)} />

				{label.length > 0 &&
					<span className="separator">-</span>
				}

				<InputLabel
					ref='label'
					label={localization.localize(label)}
					placeholder={placeholder}
					usePlaceholderLabel={this.displayPlaceholderLabel}
				/>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/main/webapps/features/form-builder/react/editor/components/form-elements/inputs/multi-choice-pay-option.js